import React, { useState } from 'react';
import ForgotPassword from 'components/ResetPassword/ForgotPassword';
import { ForgotFormData } from 'components/ResetPassword/interface';
import { forgotPasswordRequest } from 'utils/api/users';
import { PageLayoutParams, Layouts } from 'layouts/LayoutProvider';
import { Modal } from 'lmc-ui-library';
import useRebrandContext from 'helpers/hooks/useRebrandContext';

const ForgotPasswordPage: React.FC & PageLayoutParams = () => {
  const [error, setError] = useState<any>([]);
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [newUi] = useRebrandContext();

  const handleSubmit = async (values: ForgotFormData) => {
    try {
      await forgotPasswordRequest(values);
      setIsSubmitted(true);
    } catch (error) {
      setShowModal(true);
      setError(error.response.data.details.email);
    }
  };

  console.log(error);

  return (
    <>
      <ForgotPassword handleSubmitForm={handleSubmit} isSubmitted={isSubmitted} newUi={newUi} />
      {showModal && (
        <Modal showCloseBtn={true} isOpen={showModal} onClose={() => setShowModal(false)}>
          <Modal.Header title="Something went wrong!" mode="error" />
          <Modal.Content>
            {error.map((err: any) => (
              <p>{err}</p>
            ))}
          </Modal.Content>
        </Modal>
      )}
    </>
  );
};

ForgotPasswordPage.layout = Layouts.REGISTRATION;

export default ForgotPasswordPage;
